import {stateData, reduxState} from '../../values';

export const getFares = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_fares,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateFares = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_fares,
            payload:    data,
        })
    }
}